import type { StructureEntity } from '@/components/structure/useStructureEntities';

export const hasUniqEntityConnected = (structure: StructureEntity[], connectionKind: string) => {
	return structure.some((entity) =>
		entity.connections?.some(
			(c) => c.isUnique && c.connectionKind === connectionKind && c.connectedEntities?.length > 0,
		),
	);
};
